var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal",
      attrs: {
        id: "accountingReportModal",
        maximized: _vm.maximized,
        value: _vm.accountingReportModal
      },
      on: {
        hide: function($event) {
          _vm.closeModal("accountingReport")
        }
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c(
                "q-toolbar-title",
                [
                  _c("q-icon", { attrs: { name: "fa fa-money" } }),
                  _vm._v(" Accounting Report\n    ")
                ],
                1
              ),
              _c("q-icon", {
                attrs: { name: "clear" },
                nativeOn: {
                  click: function($event) {
                    _vm.closeModal("accountingReport")
                  }
                }
              })
            ],
            1
          ),
          _c("div", { staticStyle: { padding: "40px 20px" } }, [
            _c("div", { staticClass: "sl-row" }, [
              _c("div", { staticClass: "sl-col-12" }, [
                _c(
                  "p",
                  {
                    staticClass: "text-center",
                    staticStyle: { "max-width": "350px", margin: "0 auto" }
                  },
                  [
                    _vm._v(
                      "This report shows all the classes and fees collected for a given date range."
                    )
                  ]
                )
              ])
            ]),
            _c("div", { staticClass: "sl-row" }, [
              _c(
                "div",
                { staticClass: "sl-col-12" },
                [
                  _c(
                    "q-field",
                    [
                      _c("q-select", {
                        attrs: {
                          "float-label": "Report Type",
                          options: _vm.reportTypes,
                          clearable: "",
                          "autofocus-filter": ""
                        },
                        model: {
                          value: _vm.selectedReportType,
                          callback: function($$v) {
                            _vm.selectedReportType = $$v
                          },
                          expression: "selectedReportType"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "sl-row", staticStyle: { margin: "0" } }, [
              _c(
                "div",
                { staticClass: "sl-col-6" },
                [
                  _c("q-datetime", {
                    attrs: { "stack-label": "Start Date", max: _vm.today },
                    model: {
                      value: _vm.startDate,
                      callback: function($$v) {
                        _vm.startDate = $$v
                      },
                      expression: "startDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sl-col-6" },
                [
                  _c("q-datetime", {
                    attrs: { "stack-label": "End Date", max: _vm.today },
                    model: {
                      value: _vm.endDate,
                      callback: function($$v) {
                        _vm.endDate = $$v
                      },
                      expression: "endDate"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "sl-row q-mb-none" }, [
              _vm.selectedReportType === "class"
                ? _c(
                    "div",
                    { staticClass: "sl-col-12" },
                    [
                      _c("course-autocomplete", {
                        attrs: { select: _vm.onSelectCourse }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.selectedReportType === "order"
                ? _c(
                    "div",
                    { staticClass: "sl-col-12" },
                    [
                      _c(
                        "q-field",
                        [
                          _c("q-select", {
                            attrs: {
                              "float-label": "Order Type",
                              options: _vm.orderTypes,
                              clearable: "",
                              filter: "",
                              "autofocus-filter": ""
                            },
                            model: {
                              value: _vm.selectedOrderType,
                              callback: function($$v) {
                                _vm.selectedOrderType = $$v
                              },
                              expression: "selectedOrderType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]),
          _c(
            "q-toolbar",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("q-toolbar-title"),
              _c("q-btn", {
                attrs: { color: "green", icon: "fa fa-gear", label: "Run" },
                nativeOn: {
                  click: function($event) {
                    _vm.runReport()
                  }
                }
              }),
              _vm._v(" \n      "),
              _c("q-btn", {
                attrs: { outline: "", color: "faded", label: "Cancel" },
                nativeOn: {
                  click: function($event) {
                    _vm.closeModal("accountingReport")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }